import { Link } from "react-router-dom"
import { footerLinkClass } from "../lightTheme"

const footerLinks = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/contact", label: "Contact Us" },
]

export default function LightFooter() {
  return (
    <div className="w-full max-w-[1200px]">
      <footer className="ml-[calc(50vw-50%-1.5rem)] flex w-full flex-wrap items-center justify-end bg-[#FAFAFA] pb-10 pt-24">
        {footerLinks.map((link, index) => (
          <span key={link.to} className="inline-flex items-center">
            {index > 0 ? (
              <span aria-hidden="true" className="px-2 text-[10px] leading-none text-[#4D4D4D]">
                ·
              </span>
            ) : null}
            <Link className={footerLinkClass} to={link.to}>
              {link.label}
            </Link>
          </span>
        ))}
      </footer>
    </div>
  )
}
